export default __webpack_public_path__ + "static/media/cancelCollect.0d676635.svg";